import { Inject, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Jsonp } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import { APP_CONFIG } from '../app.config';
import { IAppConfig } from '../app.config.shared';
import { CommonRequestResponseService } from './common-request-response.service';
import { CommonRouteFunctionService } from './common-routing-service';
import { NotificationService } from './notification.service';
import { CommonDataSharedService } from './commonDataSharedService';

declare var window;
declare const InstallTrigger: any;

export class AsyncHandler {
  private e;
  private errFn;

  constructor(e) {
    this.e = e;
  }

  Ok(resolve: Function) {
    const _this = this;
    this.e(resolve, (data: any) => {
      if (_this.errFn) {
        _this.errFn(data);
      }
    });
    return this;
  }

  Error(reject: Function) {
    this.errFn = reject;
    return this;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  detailData;
  intValidator;
  timeInterval;
  dataObject = {};
  // collegeDetail: any;
  coachingHoursList: Observable<any[]>;
  secondNavMessage: Observable<any>;
  private subject = new Subject();
  private radix = 10; // conforming to radix parameter use for parseInt() instances. 10 === decimal
  constructor(
    private jsonp: Jsonp,
    private commonRouteFunctionService: CommonRouteFunctionService,
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private datePipe: DatePipe,
    private _commonDataSharedService: CommonDataSharedService,
    @Inject(APP_CONFIG) private config: IAppConfig) { }

  checkCurrentBrowser() {
    // Return cached result if avalible, else get result then cache it.
    // Opera 8.0+
    const isOpera = (!!window['opr'] && !!window['opr'].addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    const isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]"
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window['safari'] || window['safari'].pushNotification);

    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!window.document['documentMode'];

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1+
    const isChrome = !!window.chrome && !!window.chrome.webstore;

    // Blink engine detection
    const isBlink = (isChrome || isOpera) && !!window.CSS;

    return isOpera ? 'Opera' : isFirefox ? 'Firefox' : isSafari ? 'Safari' : isChrome ? 'Chrome' : isIE ? 'IE' : isEdge ? 'Edge' : isBlink ? 'Blink' : 'Dont know';
  }

  setData(detailData) {
    this.detailData = detailData;
    this.subject.next(detailData);
  }

  getData() {
    return this.subject.asObservable();
  }


  setDataWithoutObservable(object, key) {
    this.dataObject[key] = object;
  }

  getDataWithoutObservable(key) {
    return this.dataObject[key];
  }

  convertArrayOfObjectToArray(arr: Object) {
    const finalArr = [];
    for (let i = 0; i < Object.keys(arr).length; i++) {
      const tempArray = [];
      tempArray[0] = arr[i].name;
      tempArray[1] = parseInt(arr[i].value, this.radix);
      finalArr.push(tempArray);
    }
    return finalArr;
  }

  toggleSideMenu(routeArray, currentRoute) {
    for (let i = 0; i < routeArray.length; i++) {
      if (currentRoute.path === routeArray[i].path) {
        currentRoute.clicked = !currentRoute.clicked;
      } else {
        routeArray[i].clicked = false;
      }
    }

  }

  callAppropiateApi(e: any, comesFrom: String, parameter: any) {
    const webUrl = 'admin/content/autocomplete';
    let inputJson;
    if (comesFrom === 'heatMap') {
      inputJson = {
        contentId: parameter.contentId,
        partnerId: parameter.partnerId,
        BrickId: parameter.brickId,
        Completed: 1
      }
    } else {
      const data = +(e.target.a.id.toString().split('id')[1]);
      inputJson = {
        userId: parameter.studentUserId.toString(),
        contentId: parameter.items[data].articleid,
        partnerId: parameter.partnerId,
        Completed: 1
      }
    }

    this._commonDataSharedService.reRenderMyPlan.subscribe(() => {
      clearTimeout(this.timeInterval);
    })

    if (e.data === 1) {
      const duration = e.target.getDuration() * 3 / 4 * 1000;
      if (comesFrom === 'heatMap' && duration) {
        this.timeInterval = setTimeout(() => {
          this._commonRequestResponseService.postWithHeader(webUrl, inputJson)
            .subscribe(
              () => {
                this._commonDataSharedService.autoBrick.next();
              },
              () => {
                this.notificationService.show('error', 'Error While Fetching Brick Data');
              }
            );

        }, duration);
      }
      else {
        this._commonRequestResponseService.postWithHeader(webUrl, inputJson)
          .subscribe(
            () => {
              this._commonDataSharedService.autoBrick.next();
            },
            () => {
              this.notificationService.show('error', 'Error While Fetching Brick Data');
            }
          );

      }


    }
  }

  youTubeApi(iframeInstance: any, videoInstance: any, comesFrom: String, inputJson: any) {
    const date = new Date().getTime();
    let player;
    iframeInstance.forEach((c, i) => {
      const id = date + 'id' + i;
      c.setAttribute('id', id);
      if (c.getAttribute('urlvid') && c.getAttribute('urlvid').includes('youtube.com')) {
        c.src = c.getAttribute('urlvid').split('?')[0] + '?enablejsapi=1&html5=1'
        player = new (window as any).YT.Player(id, {
          events: {
            'onStateChange': (e) => {
              this.callAppropiateApi(e, comesFrom, inputJson);
            }
          }
        });
      } else if (c.getAttribute('src') && c.getAttribute('src').includes('vimeo.com')) {
        c.style.display = 'block';
      } else {
        c.style.display = 'none';
      }
    });

    videoInstance.forEach((c, i) => {
      if (!c.getAttribute('urlvid') || !c.getAttribute('urlvid').includes('youtube.com')) {
        const source = document.createElement('source');
        source.setAttribute('src', c.getAttribute('urlvid'));
        c.appendChild(source);
        c.onplay = (e) => {
          this.callAppropiateApi(e, comesFrom, inputJson)
        }
      } else {
        c.style.display = 'none';
      }
    });

    return player;
  }

  validate_int(myEvento) {
    if ((myEvento.charCode >= 48 && myEvento.charCode <= 57) || myEvento.keyCode === 9 || myEvento.keyCode === 10 || myEvento.keyCode === 13 || myEvento.keyCode === 8 || myEvento.keyCode === 116 || myEvento.keyCode === 46 || (myEvento.keyCode <= 40 && myEvento.keyCode >= 37)) {
      this.intValidator = true;
    } else {
      this.intValidator = false;
    }
    return this.intValidator;
  }

  phone_number_mask(keyData) {
    const myMask = '___-___-____';
    let myText;
    const myNumbers = [];
    let myOutPut = ''
    let theLastPos = 1;
    myText = keyData.value;
    // get numbers
    for (let i = 0; i < myText.length; i++) {
      if (!isNaN(myText.charAt(i)) && myText.charAt(i) !== ' ') {
        myNumbers.push(myText.charAt(i));
      }
    }
    // write over mask
    for (let j = 0; j < myMask.length; j++) {
      if (myMask.charAt(j) === '_') { // replace "_" by a number
        if (myNumbers.length === 0) {
          myOutPut = myOutPut + myMask.charAt(j);
        } else {
          myOutPut = myOutPut + myNumbers.shift();
          theLastPos = j + 1; // set caret position
        }
      } else {
        myOutPut = myOutPut + myMask.charAt(j);
      }
    }
    keyData.value = myOutPut;
    keyData.setSelectionRange(theLastPos, theLastPos);
  }

  findUnique(array) {
    const result = [];
    array.forEach(function (d) {
      if (result.indexOf(d) === -1) {
        result.push(d);
      }
    });
    return result;
  }

  getGradeText(array, gradeLevelData) {
    for (let i = 0; i < array.length; i++) {
      if (array[i]['Grade Level'] && gradeLevelData) {
        array[i]['Grade Level'] = gradeLevelData[array[i]['Grade Level']]
      }
    }
    return array;
  }


  getSubjectText(array, gradeLevelData) {
    for (let i = 0; i < array.length; i++) {
      if (array[i]['Subject']) {
        array[i]['Subject'] = gradeLevelData[array[i]['Subject']]
      }
    }
    return array;
  }

  checkDeviceIsMobile() {
    const browser = window.navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(browser)) {
      return true;
    } else {
      return false;
    }


  }

  checkMaxLength(data, length) {
    let flag = true;
    if ((data && data.toString().length + 1) > length || data === 0) {
      flag = false
    }
    return flag;
  }

  RemoveRougeChar(convertString) {
    // let convertString =  string.replace(/(.{3})/g,"$1,").split("").reverse().join("");
    if (convertString.substring(0, 1) === ',') {
      return convertString.substring(1, convertString.length)
    }
    return convertString;
  }

  numberToPhone(number) {
    if (number) {
      return number.replace(/\D+/g, '').replace(/([0-9]{3})([0-9]{3})([0-9]{4}$)/gi, '$1-$2-$3'); // mask numbers (xxx) xxx-xxxx
    } else {
      return '';
    }
  };

  dynamicSort(property, flag) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      let aLower;
      let bLower;
      if (typeof (a[property]) === 'string') {
        aLower = flag ? a[property].toLowerCase() : (a[property] ? a[property].toLowerCase() : '0000000000000'); //If null make it as Z for sorting
        bLower = flag ? b[property].toLowerCase() : (b[property] ? b[property].toLowerCase() : '0000000000000'); // If null make it as Z for sorting
      }
      else if (typeof (a[property]) === 'number') {
        aLower = flag ? a[property] : (a[property] ? a[property] : '00000000000000');
        bLower = flag ? b[property] : (b[property] ? b[property] : '00000000000000');
      }
      else if (typeof (a[property]) === 'boolean') {
        aLower = flag ? a[property] : (a[property] ? a[property] : '');
        bLower = flag ? b[property] : (b[property] ? b[property] : '');
      }

      const result = (aLower < bLower) ? -1 : (aLower > bLower) ? 1 : 0;
      return result * sortOrder;
    }
  }

  dynamicDateSort(property, flag) {
    let sortOrder = -1;
    if (property[0] === '-') {
      sortOrder = 1;
      property = property.substr(1);

    }
    return function (a, b) {
      const aLower = a[property] ? new Date(a[property]) : '';
      const bLower = b[property] ? new Date(b[property]) : '';
      const result = (aLower < bLower) ? -1 : (aLower > bLower) ? 1 : 0;
      return result * sortOrder;
    }
  }

  dynamicDateMessageSort(property, flag) {
    let sortOrder = -1;
    if (property[0] === '-') {
      sortOrder = 1;
    }
    return function (a, b) {
      const aLower = a.messageDate ? new Date(a.messageDate) : '';
      const bLower = b.messageDate ? new Date(b.messageDate) : '';
      const result = (aLower < bLower) ? -1 : (aLower > bLower) ? 1 : 0;
      return result * sortOrder;
    }
  }

  setBreadCrumb(route, routerList, module) {
    let breadCrumbText = module;
    let parentBreadCrumb = '';
    const parentExistIndex = this.checkParentExist(routerList, route);
    if (parentExistIndex.innerIndex > -1) {
      parentBreadCrumb = routerList[parentExistIndex.mainIndex].path
      breadCrumbText = breadCrumbText + '/' + parentBreadCrumb;
    };
    breadCrumbText = breadCrumbText + '/' + route.path;
    this.commonRouteFunctionService.breadCrumb.next(breadCrumbText);
  }

  checkParentExist(routerList, routeData) {
    const returnIndexObject = { mainIndex: -1, innerIndex: -1 };
    // for (let i = 0; i < routerList.length; i++) {
    //   if (routerList[i].innerItems.length > 0) {
    //     for (let j = 0; j < routerList[i].innerItems.length; j++) {
    //       if (routerList[i].innerItems[j].path === routeData.path) {
    //         return { mainIndex: i, innerIndex: j };
    //       }
    //     }

    //   }
    // }
    return returnIndexObject;
  }

  fuzzysearch(needle, haystack) {
    const haystackLC = haystack.toLowerCase();
    const needleLC = needle.toLowerCase();

    const hlen = haystack.length;
    const nlen = needleLC.length;

    if (nlen > hlen) {
      return false;
    }
    if (nlen === hlen) {
      return needleLC === haystackLC;
    }
    outer: for (let i = 0, j = 0; i < nlen; i++) {
      const nch = needleLC.charCodeAt(i);

      while (j < hlen) {
        if (haystackLC.charCodeAt(j++) === nch) {
          continue outer;
        }
      }
      return false;
    }
    return true;
  }


  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    const charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  isTestTakenDateValid(testTakenDate, maxDate) {
    let returnData = true;
    if (testTakenDate) {
      const date = new Date(testTakenDate);
      const max = new Date(maxDate);
      if (date > max) {
        returnData = false;
      }

    }
    return returnData;
  }

  hideHelpMenuAndPopup() {
    if (document.querySelector('.SnapABug_Button') || document.querySelector('#SnapABug_WP')) {
      document.querySelector('.SnapABug_Button').remove();
      document.querySelector('#SnapABug_WP').remove();
      document.querySelector('#SnapABug_W').remove();
    }
    if (document.querySelector('#designstudio-button')) {
      document.querySelector('#designstudio-button').remove();
    }
    if (document.querySelector('#snapengage-button')) {
      document.querySelector('#snapengage-button').remove();
    }
    if (document.querySelector('#snapengage-mobile')) {
      document.querySelector('#snapengage-mobile').remove();
    }
    if (document.querySelector('#designstudio')) {
      document.querySelector('#designstudio').remove();
    }
  }

  showHelpMenuAndPopup() {
    if (document.querySelector('.SnapABug_Button') || document.querySelector('#SnapABug_WP')) {
      document.querySelector('.SnapABug_Button')['style']['display'] = 'block';
    }
    if (document.querySelector('#designstudio-button')) {
      document.querySelector('#designstudio-button')['style']['display'] === 'none' ? document.querySelector('#designstudio-button')['style']['display'] = 'block' : document.querySelector('#designstudio-button')['style']['display'] = 'block';
    }
  }

  getCurrentIpAddress() {

    let ipData;
    this.jsonp.get('https://jsonip.com/?callback=JSONP_CALLBACK')
      .subscribe((response: any) => {
        ipData = response.json()['ip'];
        return ipData;
      }, (err) => {
        console.error(err);

      })
  }

  scrollToPosition(y) {
    window.scrollTo(0, y);
  }

  checkCommaSeparatedEmailValidation(trim, emailData) {
    const member_split = emailData.split(',');
    let valid = true;
    for (let n = 0; n < member_split.length; n++) {
      const member_info = trim ? member_split[n].trim() : member_split[n];
      const validRegExp = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;

      if (member_info.search(validRegExp) === -1) {
        valid = false;
        break;
      }
    }
    if (valid) {
      return true;
    } else {
      return false;
    }
  }

  setParentMessageTabsData(data) {
    localStorage.setItem('parentMessageTabsData', JSON.stringify(data));
  }

  getParentMessageTabsData() {
    return JSON.parse(localStorage.getItem('parentMessageTabsData'));
  }

  searchInTable(arrayData, columnName, stringToMatch): any[] {
    if (!arrayData || !arrayData.length) {
      return [];
    }
    let resultantArray = [];
    if (stringToMatch) {
      resultantArray = arrayData.filter((data: any) => {
        if (data && data[columnName] && data[columnName].toLowerCase().includes(stringToMatch.toLowerCase())) {
          return data;
        }
      });
      return resultantArray;
    } else {
      return arrayData;
    }
  }

  searchInSeveralFields(inputArray, columnNames: string[], matcher: string): any[] {
    if (!matcher) {
      return inputArray;
    }

    return inputArray.filter(
      (item) => {
        for (let i = 0; i < columnNames.length; i++) {
          if (item[columnNames[i]] && item[columnNames[i]].toLowerCase().includes(matcher.toLowerCase())) {
            return item;
          }
        }
      });
  }

  chooseFileEvent = file => (new AsyncHandler((resolve, reject) => {
    let arrayBuffer;
    let array;
    let obj = {};
    const reader = new FileReader();
    // get the selected file from event
    reader.onload = () => {
      arrayBuffer = reader.result,
        array = new Uint8Array(arrayBuffer)
    }
    reader.onloadend = () => {
      obj = { fileName: file.name, fileBytes: array };
      resolve(obj);
    };
    reader.readAsArrayBuffer(file);
  }));

  formatDate(message: any) {
    message.messageDate = message.messageDate || message.threadCreated;
    const dateSplit = this.datePipe.transform(message.messageDate.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'), 'MM/dd, y, h:mm a', 'es-ES').split(', ');
    message.dateFormatted = `${dateSplit[0]}/${dateSplit[1]}<br> ${dateSplit[2]}`;
    if (message.dateCompleted) {
      const dateCompletedSplit = this.datePipe.transform(message.dateCompleted.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'), 'MM/dd, y, h:mm a', 'es-ES').split(', ');
      message.dateCompletedFormatted = `${dateCompletedSplit[0]}/${dateCompletedSplit[1]}<br> ${dateCompletedSplit[2]}`;
    }
  }
}

